import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Flag, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ReportReviewButton({ reviewId }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/reviews/${reviewId}/report`, { reason: reason.trim() });
      toast.success("Thanks — our team will take a look.");
      setOpen(false); setReason("");
    } catch { toast.error("Could not submit the report"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <button data-testid={`report-review-${reviewId}`} onClick={() => setOpen(true)}
        className="mt-2 inline-flex items-center gap-1 text-xs text-zinc-400 hover:text-zinc-700">
        <Flag className="h-3 w-3" /> Report review
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="report-review-dialog">
          <DialogHeader>
            <DialogTitle>Report this review</DialogTitle>
            <DialogDescription>Tell us what's wrong with this review. Our team will review it — reviews are never edited, only hidden or restored.</DialogDescription>
          </DialogHeader>
          <Textarea data-testid="report-reason" rows={4} value={reason} maxLength={500}
            onChange={(e) => setReason(e.target.value)} placeholder="Why are you reporting this review?" className="resize-none" />
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setOpen(false)} className="rounded-full">Cancel</Button>
            <Button data-testid="report-submit" onClick={submit} disabled={busy} className="rounded-full bg-zinc-900 hover:bg-zinc-800">
              {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Flag className="mr-1 h-4 w-4" />} Submit report
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
